import type { ReactNode } from "react";

export function Eyebrow({ children, count, right }: { children: ReactNode; count?: number; right?: ReactNode }) {
  return (
    <div className="flex items-center justify-between mb-3">
      <div className="flex items-center gap-2">
        <span className="label-eyebrow">{children}</span>
        {count !== undefined && (
          <span className="text-[10px] text-muted-foreground font-mono">{count}</span>
        )}
      </div>
      {right}
    </div>
  );
}